import { render, staticRenderFns } from "./sold-products.vue?vue&type=template&id=3847b2ec&scoped=true"
import script from "./sold-products.vue?vue&type=script&lang=js"
export * from "./sold-products.vue?vue&type=script&lang=js"
import style0 from "./sold-products.vue?vue&type=style&index=0&id=3847b2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3847b2ec",
  null
  
)

export default component.exports